export enum GENDER {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
    DIVERS = 'DIVERS',
}

export interface M020C030InputSelectOption {
    label: string;
    value: string | number;
}
